import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * Banner de Consentimento de Cookies conforme LGPD
 * Aparece na primeira visita e salva escolha no localStorage
 */
export const CookieConsent: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        // Verificar se usuário já respondeu
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            // Aguardar 15s antes de mostrar (UX mais suave para melhorar connect rate/retenção)
            const timer = setTimeout(() => setIsVisible(true), 15000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        localStorage.setItem('cookieConsentDate', new Date().toISOString());
        closeBanner();
    };

    const handleReject = () => {
        localStorage.setItem('cookieConsent', 'rejected');
        localStorage.setItem('cookieConsentDate', new Date().toISOString());
        // Desabilitar Analytics se implementado na web
        closeBanner();
    };

    const closeBanner = () => {
        setIsClosing(true);
        setTimeout(() => setIsVisible(false), 300);
    };

    if (!isVisible) return null;

    return (
        <div
            className={`fixed bottom-0 left-0 right-0 z-50 p-4 pb-safe-bottom transition-all duration-300 ${isClosing ? 'translate-y-full opacity-0' : 'translate-y-0 opacity-100'
                }`}
        >
            <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 p-6">
                <div className="flex items-start gap-4">
                    <div className="flex-1">
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                            🍪 Este site usa cookies
                        </h3>
                        <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
                            Usamos cookies essenciais para manter você conectado e cookies analíticos para
                            melhorar sua experiência. Ao clicar em "Aceitar", você concorda com o uso de{' '}
                            <strong>cookies essenciais e analíticos</strong>. Você pode revisar nossa{' '}
                            <a
                                href="/#/privacy"
                                className="text-primary hover:underline font-medium"
                                target="_blank"
                            >
                                Política de Privacidade
                            </a>{' '}
                            e{' '}
                            <a
                                href="/#/terms"
                                className="text-primary hover:underline font-medium"
                                target="_blank"
                            >
                                Termos de Uso
                            </a>
                            .
                        </p>
                        <div className="flex flex-wrap gap-3">
                            <button
                                onClick={handleAccept}
                                className="px-6 py-2.5 bg-primary hover:bg-primary/90 text-white font-medium rounded-xl transition-colors shadow-sm"
                            >
                                Aceitar cookies
                            </button>
                            <button
                                onClick={handleReject}
                                className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-900 dark:text-white font-medium rounded-xl transition-colors"
                            >
                                Apenas essenciais
                            </button>
                        </div>
                    </div>
                    <button
                        onClick={closeBanner}
                        className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                        aria-label="Fechar"
                    >
                        <X size={20} className="text-gray-500 dark:text-gray-400" />
                    </button>
                </div>
            </div>
        </div>
    );
};
